module.exports = __webpack_public_path__ + "static/media/sample-video.667bc1fa.mp4";